import axios from 'axios';

export const state = {
  accounts: [],
  accountsPagination: {},
  loading: false,
};

export const mutations = {
  setAccounts(context, accounts) {
    context.accounts = accounts;
    context.loading = false;
  },

  setAccountsPagination(context, pagination) {
    context.accountsPagination = pagination;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getAccounts({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const accounts = await axios.get(`${window.BASE_API.BAADER}/accounts?${query}`, options)
        .then(response => response.data);

      commit('setAccounts', accounts.data);
      commit('setAccountsPagination', accounts.pagination);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const baaderAccountsStore = {
  state,
  mutations,
  actions,
};

export default baaderAccountsStore;



// WEBPACK FOOTER //
// ./src/store/baader/baaderAccountsStore.js